export default "//static.tradera.net/touchweb/static/output/images/multicolor.45085a87.svg";